import React from 'react'

interface IconToggleProps {
    onClick(): void;
    className: string;
    title?: string;
}

export const IconToggle: React.FC<IconToggleProps> = ({
    onClick,
    className,
    title = "",
}) => (
    <a
        onClick={onClick}
        title={title}
        className={className}
        style={{ width: "auto" }}
    />
);